<template>
  <v-data-table
    :headers="headersItems"
    :items="data"
    :no-results-text="noResultText"
    :hide-actions="hideActions"
    class="w-100"
  >
    <template v-slot:items="props">
      <td
        v-for="(pr, i) in headersItems"
        :key="`prop-${i}`"
        :class="pr.rowClass"
      >
        {{ props.item[pr.value] }}
      </td>
    </template>
  </v-data-table>
</template>

<script>
// Rehacer el listado de tabla
export default {
  data() {
		return {
			data: []
		}
	},
  props: ['headersItems', 'dataItems', 'noResultText', 'hideActions', 'tabsItem'],
  created(){

    if( !Array.isArray(this.dataItems)  ){
      
    
      for(var i in this.dataItems){
        
        if( i != 'sexo' ){
          var elemento = {
            tipo: i,
            elemento_inferior: this.dataItems[i].inferior,
            elemento_superior: this.dataItems[i].superior,
            inferior: this.dataItems[i].elemento_inferior,
            superior: this.dataItems[i].elemento_superior,
            variable: this.dataItems[i].variable,
          }
          
          if( i == "anyo"){
            this.data[0] = elemento
          }else if( i == "mes"){
            this.data[1] = elemento
          }else if( i == "dia"){
            this.data[2] = elemento
          }else{
            this.data.push(elemento);
          }
          
       }
       
      }
      
    }else{
        this.data = this.dataItems
    }
    
  }
}
</script>
